[
  {
    "id": "bat",
    "platstyper": ["bat"],
    "namn": "Båt",
    "text": {
      "batkoll": "Båtkoll håller koll på elen, tankarna, motorerna och vädret ombord."
    },
    "kort": [
      {
        "namn": "Förbrukningsbanken",
        "omrade": "el"
      },
      {
        "namn": "Landström",
        "omrade": "el"
      },
      {
        "namn": "Laddning",
        "omrade": "el"
      },
      {
        "namn": "Startbatterierna",
        "omrade": "el"
      },
      {
        "namn": "Tankar",
        "omrade": "motor"
      },
      {
        "namn": "Motorerna",
        "omrade": "motor"
      },
      {
        "namn": "Räckvidden",
        "omrade": "motor"
      },
      {
        "namn": "Temperaturer",
        "omrade": "varme"
      },
      {
        "namn": "Vattnet",
        "omrade": "vader"
      },
      {
        "namn": "Position",
        "omrade": "sakerhet"
      },
      {
        "namn": "Vinterläge",
        "omrade": "el"
      }
    ],
    "granser": [
      {
        "grans": "landstrom.akut_procentenheter",
        "varde": 5,
        "text": "Akut när landströmmen har försvunnit och förbrukningsbanken har sjunkit 5 procentenheter"
      },
      {
        "grans": "forbrukning.varning_procent",
        "varde": 50,
        "text": "Varning när förbrukningsbanken är under 50 %"
      },
      {
        "grans": "lanspump.akut_minuter",
        "varde": 2,
        "text": "Akut när länspumpen har gått i 2 minuter"
      },
      {
        "grans": "kabin.frost_grader",
        "varde": 2,
        "text": "Varning för frost när kabinen är kallare än 2 °C"
      },
      {
        "grans": "nav.tyst_minuter",
        "varde": 15,
        "text": "Varning när navet inte har hörts av på 15 minuter"
      },
      {
        "grans": "vind.kuling_ms",
        "varde": 14,
        "text": "Varning för hård vind när prognosen visar 14 m/s i medel"
      },
      {
        "grans": "tank.svartvatten_varning_procent",
        "varde": 75,
        "text": "Varning när svartvattentanken är över 75 %"
      }
    ],
    "larm": [
      "Akut när länspumpen går länge, och när landströmmen försvinner och banken sjunker",
      "Varning för låg förbrukningsbank, frost i kabinen och hård vind",
      "Varning när navet är tyst",
      "Motorernas egna varningar under resan"
    ]
  },
  {
    "id": "hus",
    "platstyper": ["hus", "annat"],
    "namn": "Hus",
    "text": {
      "stugkoll": "Stugkoll håller koll på värmen, elen, vattnet och vädret i huset."
    },
    "kort": [
      {
        "namn": "Inne",
        "omrade": "varme"
      },
      {
        "namn": "Zoner",
        "omrade": "varme"
      },
      {
        "namn": "Planer",
        "omrade": "varme"
      },
      {
        "namn": "Ute",
        "omrade": "vader"
      },
      {
        "namn": "Energi",
        "omrade": "el"
      },
      {
        "namn": "Vattenläcka",
        "omrade": "vatten"
      },
      {
        "namn": "Kyl och frys",
        "omrade": "varme"
      },
      {
        "namn": "Jordfukt",
        "omrade": "vatten"
      },
      {
        "namn": "Givare",
        "omrade": "varme"
      }
    ],
    "granser": [
      {
        "grans": "hus.inne_min_grader",
        "varde": 5,
        "text": "Varning när det är kallare än 5 °C inne"
      },
      {
        "grans": "hus.kalla_tyst_minuter",
        "varde": 15,
        "text": "Varning när navet inte har nått Home Assistant eller Nobø-hubben på 15 minuter"
      },
      {
        "grans": "nav.tyst_minuter",
        "varde": 15,
        "text": "Varning när navet inte har hörts av på 15 minuter"
      },
      {
        "grans": "forvarmning.timmar",
        "varde": 2,
        "text": "Förvärmningen börjar 2 timmar före ankomsten"
      },
      {
        "grans": "vader.is_temp_grader",
        "varde": 2,
        "text": "Misstänkt is i väderstationen när det är kallare än 2 °C"
      }
    ],
    "larm": [
      "Varning när det är för kallt inne, i huset eller i en zon",
      "Akut vid en vattenläcka",
      "Akut med push när en brandvarnare larmar, också under de tysta tiderna",
      "Varning när navet är tyst",
      "Varning när jorden har varit torr i mer än 6 timmar"
    ]
  },
  {
    "id": "fritidshus",
    "platstyper": ["fritidshus"],
    "namn": "Fritidshus",
    "text": {
      "stugkoll": "Stugkoll håller koll på fritidshuset mellan besöken, och värmer upp det till lägsta kostnad före ankomsten."
    },
    "kort": [
      {
        "namn": "Läge",
        "omrade": "varme"
      },
      {
        "namn": "Inne",
        "omrade": "varme"
      },
      {
        "namn": "Zoner",
        "omrade": "varme"
      },
      {
        "namn": "Planer",
        "omrade": "varme"
      },
      {
        "namn": "Ute",
        "omrade": "vader"
      },
      {
        "namn": "Energi",
        "omrade": "el"
      },
      {
        "namn": "Vattenläcka",
        "omrade": "vatten"
      },
      {
        "namn": "Kyl och frys",
        "omrade": "varme"
      },
      {
        "namn": "Jordfukt",
        "omrade": "vatten"
      },
      {
        "namn": "Givare",
        "omrade": "varme"
      }
    ],
    "granser": [
      {
        "grans": "hus.inne_min_grader",
        "varde": 5,
        "text": "Varning när det är kallare än 5 °C inne"
      },
      {
        "grans": "hus.kalla_tyst_minuter",
        "varde": 15,
        "text": "Varning när navet inte har nått Home Assistant eller Nobø-hubben på 15 minuter"
      },
      {
        "grans": "nav.tyst_minuter",
        "varde": 15,
        "text": "Varning när navet inte har hörts av på 15 minuter"
      },
      {
        "grans": "forvarmning.timmar",
        "varde": 20,
        "text": "Förvärmningen börjar 20 timmar före ankomsten"
      },
      {
        "grans": "vader.is_temp_grader",
        "varde": 2,
        "text": "Misstänkt is i väderstationen när det är kallare än 2 °C"
      }
    ],
    "larm": [
      "Varning när det är för kallt inne, i huset eller i en zon",
      "Akut vid en vattenläcka",
      "Akut med push när en brandvarnare larmar, också under de tysta tiderna",
      "Varning när navet är tyst",
      "Varning när jorden har varit torr i mer än 6 timmar",
      "Varning för misstänkt is i väderstationen"
    ]
  },
  {
    "id": "husbil",
    "platstyper": ["husbil"],
    "namn": "Husbil",
    "text": {
      "husbilskoll": "Husbilskoll håller koll på värmen, elen och fukten i husbilen."
    },
    "kort": [
      {
        "namn": "Inne",
        "omrade": "varme"
      },
      {
        "namn": "Ute",
        "omrade": "vader"
      },
      {
        "namn": "Energi",
        "omrade": "el"
      },
      {
        "namn": "Givare",
        "omrade": "varme"
      }
    ],
    "granser": [
      {
        "grans": "hus.inne_min_grader",
        "varde": 5,
        "text": "Varning när det är kallare än 5 °C inne"
      },
      {
        "grans": "hus.kalla_tyst_minuter",
        "varde": 15,
        "text": "Varning när navet inte har nått sina källor på 15 minuter"
      },
      {
        "grans": "nav.tyst_minuter",
        "varde": 15,
        "text": "Varning när navet inte har hörts av på 15 minuter"
      }
    ],
    "larm": [
      "Varning när det är för kallt inne",
      "Akut med push när en brandvarnare larmar, också under de tysta tiderna",
      "Varning när navet är tyst"
    ]
  },
  {
    "id": "med_generator",
    "platstyper": ["bat"],
    "namn": "Med generator",
    "text": "Motorerna som navet hör, och generatorn, som tar från den första tanken.",
    "kort": [],
    "granser": [],
    "larm": [],
    "bat": {
      "motorer": [
        {
          "plats": "generator",
          "sort": "generator",
          "namn": "Generatorn",
          "instans": "ledig",
          "tank": 0
        }
      ],
      "tankar": [],
      "segelbat": false,
      "bas": "efter_hort",
      "villkor": {
        "generator": true
      }
    }
  },
  {
    "id": "fyra_utombordare",
    "platstyper": ["bat"],
    "namn": "Fyra utombordare",
    "text": "Fyra utombordare, två på varje sida, som tar från en gemensam tank.",
    "kort": [],
    "granser": [],
    "larm": [],
    "bat": {
      "motorer": [
        {
          "plats": "babord",
          "sort": "utombordare",
          "namn": "Babord yttre",
          "instans": 0,
          "tank": 0
        },
        {
          "plats": "babord2",
          "sort": "utombordare",
          "namn": "Babord inre",
          "instans": 1,
          "tank": 0
        },
        {
          "plats": "styrbord2",
          "sort": "utombordare",
          "namn": "Styrbord inre",
          "instans": 2,
          "tank": 0
        },
        {
          "plats": "styrbord",
          "sort": "utombordare",
          "namn": "Styrbord yttre",
          "instans": 3,
          "tank": 0
        }
      ],
      "tankar": ["Tanken"],
      "segelbat": false,
      "villkor": {
        "minstMotorer": 4
      }
    }
  },
  {
    "id": "tre_utombordare",
    "platstyper": ["bat"],
    "namn": "Tre utombordare",
    "text": "Tre utombordare, babord, mitten och styrbord, som tar från en gemensam tank.",
    "kort": [],
    "granser": [],
    "larm": [],
    "bat": {
      "motorer": [
        {
          "plats": "babord",
          "sort": "utombordare",
          "namn": "Babord",
          "instans": 0,
          "tank": 0
        },
        {
          "plats": "mitten",
          "sort": "utombordare",
          "namn": "Mitten",
          "instans": 1,
          "tank": 0
        },
        {
          "plats": "styrbord",
          "sort": "utombordare",
          "namn": "Styrbord",
          "instans": 2,
          "tank": 0
        }
      ],
      "tankar": ["Tanken"],
      "segelbat": false,
      "villkor": {
        "minstMotorer": 3,
        "hogstMotorer": 3
      }
    }
  },
  {
    "id": "tva_oberoende",
    "platstyper": ["bat"],
    "namn": "Två motorer, oberoende",
    "text": "Två motorer med var sin tank. Räckvidden räknas per sida.",
    "kort": [],
    "granser": [],
    "larm": [],
    "bat": {
      "motorer": [
        {
          "plats": "babord",
          "sort": "inombordare",
          "namn": "Babord",
          "instans": 0,
          "tank": 0
        },
        {
          "plats": "styrbord",
          "sort": "inombordare",
          "namn": "Styrbord",
          "instans": 1,
          "tank": 1
        }
      ],
      "tankar": ["Babords tank", "Styrbords tank"],
      "segelbat": false,
      "villkor": {
        "minstMotorer": 2,
        "minstTankar": 2
      }
    }
  },
  {
    "id": "tva_gemensam",
    "platstyper": ["bat"],
    "namn": "Två motorer med gemensam tank",
    "text": "Två motorer som tar från samma tank.",
    "kort": [],
    "granser": [],
    "larm": [],
    "bat": {
      "motorer": [
        {
          "plats": "babord",
          "sort": "inombordare",
          "namn": "Babord",
          "instans": 0,
          "tank": 0
        },
        {
          "plats": "styrbord",
          "sort": "inombordare",
          "namn": "Styrbord",
          "instans": 1,
          "tank": 0
        }
      ],
      "tankar": ["Tanken"],
      "segelbat": false,
      "villkor": {
        "minstMotorer": 2
      }
    }
  },
  {
    "id": "en_motor",
    "platstyper": ["bat"],
    "namn": "En motor",
    "text": "En motor i mitten.",
    "kort": [],
    "granser": [],
    "larm": [],
    "bat": {
      "motorer": [
        {
          "plats": "mitten",
          "sort": "inombordare",
          "namn": "Motorn",
          "instans": 0,
          "tank": 0
        }
      ],
      "tankar": ["Tanken"],
      "segelbat": false,
      "villkor": {}
    }
  },
  {
    "id": "segelbat",
    "platstyper": ["bat"],
    "namn": "Segelbåt",
    "text": "En motor, och ingen räckvidd med farten nu under segling.",
    "kort": [],
    "granser": [],
    "larm": [],
    "bat": {
      "motorer": [
        {
          "plats": "mitten",
          "sort": "inombordare",
          "namn": "Motorn",
          "instans": 0,
          "tank": 0
        }
      ],
      "tankar": ["Tanken"],
      "segelbat": true
    }
  }
]
